import React, { Component } from "react";
import { withRouter } from "react-router";
import Preloader from "../../../../../CommonComponents/Preloader/Preloader";
import RecommendFlow from "../../../../../CommonComponents/RecommendFlow/RecommendFlow";
import { OneTimeExchangeStep1, TIffStep2 } from "./InfoRectangle/InfoRectangle";
import TIFFTypeSelection from "./TIFFTypeSelection";
import SoftAlert from "../../../../../CommonComponents/Info/SoftAlert/SoftAlert.js";
import TIFFRecommendAnExchangeStep2 from "./TiffRecommendAnExchangeStep2";
import TiffNotEligibleForm from "./TiffNotEligibleForm";
import Review from "./Review";
import { getPrimaryAccount } from "../../../../../utils/sessionUtil";
import Alert from "../../../../../CommonComponents/Info/Alert/Alert.js";
import { startDate, todayDate } from "../../../../../utils/commonUtil";
import PopUp from "./PopUp";
import { initiateTracking } from "../../../../../utils/commonUtil";
import { ContentProvider, ContentMessage, Types } from '../../../../../CommonComponents/ContentMessages';

class TIFFRecommendAnExchange extends Component {
  state = {
    stepConfig: [
      {
        key: 1,
        route: "/investments/recommend-an-exchange-tiff",
        description: "Exchange TIFF",
        stepContent: () => {
          const {
            valueTiffExchangeAmount,
            totalAmountIntoPool,
            poolCount
          } = this.props.poolTableInto;
          const { selectedTiffOption } = this.props;
          return (
            <OneTimeExchangeStep1
              amountFrom={valueTiffExchangeAmount}
              type={selectedTiffOption}
              amountTo={totalAmountIntoPool}
              poolCount={poolCount}
              analyticsTracking={(value) =>
                this.analyticsEditTracking(`Step 1 Exchange ${this.props.selectedTiffOption === "exchangeFromTIFF" ? "from" : "into"} TIFF`, value)
              }
            />
          );
        },
        mainContent: () => (
          <TIFFTypeSelection
            setExchangeIntoTiff={this.props.setExchangeIntoTiff
            }
            investmentPools={this.props.accDataPools.investmentPools}
            updateStepper={this.updateStepper}
            stepConfig={this.state.stepConfig}
            dataStepOne={this.props.poolTableInto}
            tiffBalanceAmount={this.props.tiffExchangeAmount}
            tiffPoolName={this.props.tiffPoolName}
            stepOneSet={this.props.stepOneSet}
            availableBalance={this.props.availableBalance}
            resetFlow={this.props.resetFlow}
            firstTiffExchnageFlag={this.props.accDataPools.firstTiffExchnage}
            tiffInfoLoading={this.props.tiifInfoLoading}
            disableFrom={this.props.disableFrom}
            disableFromOption={this.props.disableFromOption}
            setStepOne={this.props.setStepOne}
            {...this.props}
          />
        )
      },
      {
        key: 2,
        route: "/investments/recommend-an-exchange-tiff/allocate",
        description: "Recommend exchange to",
        stepContent: () => {
          const { poolCount } = this.props.poolTableFrom;
          const { valueTiffExchangeAmount } = this.props.poolTableInto;
          return (
            <TIffStep2
              poolCount={poolCount}
              valueTiffExchangeAmount={valueTiffExchangeAmount}
              analyticsTracking={(value) =>
                this.analyticsEditTracking('Step 2 Recommend exchange to', value)
              }
            />
          );
        },
        mainContent: () => (
          <TIFFRecommendAnExchangeStep2
            requestAllPoolDataTiff={this.props.requestAllPoolDataTiff}
            requestDataTiff={this.props.requestDataTiff}
            poolData={this.props.allPoolData}
            loading={this.props.allPoolLoading}
            stepOneData={this.props.poolTableInto}
            stepTwoData={this.props.poolTableFrom}
            tiffPoolName={this.props.tiffPoolName}
            stepTwoSet={this.props.stepTwoSet}
            poolDataModal={this.props.poolData}
            poolUf={this.props.poolUf}
            poolModal={this.props.poolModal}
            modalUF={this.props.modalUF}
            setPoolModalFalse={this.props.setPoolModalFalse}
            requestPoolData={this.props.requestPoolData}
            requestunderlyingFunds={this.props.requestunderlyingFunds}
            setPoolModalFalse={this.props.setPoolModalFalse}
            setStepTwo={this.props.setStepTwo}
            resetFlow={this.props.resetFlow}
            tiffFormInfo={this.props.tiifInfoData}
            allPoolFromLoading={this.props.allPoolFromLoading}
            allPoolFromData={this.props.allPoolFromData}
          />
        )
      },
      {
        key: 3,
        route: "/investments/recommend-an-exchange-tiff/review",
        description: "Review exchange & submit",
        stepContent: () => { },
        mainContent: () => (
          <Review
            selectedTiffOption={this.props.selectedTiffOption}
            poolDataInto={this.props.poolTableInto}
            poolDataFrom={this.props.poolTableFrom}
            tiffFormInfo={this.props.tiifInfoData}
            getTiffDisclaimer={this.props.getTiffDisclaimer}
            tiffDisclaimer={this.props.tiffDisclaimer}
            tiffPoolName={this.props.tiffPoolName}
            resetFlow={this.props.resetFlow}
            submitTransactionId={this.props.submitTransactionId}
            fromTiffPoolDetails={this.props.fromTiffPoolDetails}
            toTiffPoolDetails={this.props.toTiffPoolDetails}
            {...this.props}
          />
        )
      }
    ],
    exitPopUp: false,
    key: "",
    accDataPools : {}
  };

  analyticsEditTracking = (value, previousPage) => {
    let eventAction = '';
    if (previousPage === '/investments/recommend-an-exchange-tiff/allocate') {
      eventAction = 'Step 2 Recommend exchange to';
    } else if (previousPage === '/investments/recommend-an-exchange-tiff/review') {
      eventAction = `Step ${this.props.selectedTiffOption === "exchangeFromTIFF" ? "3" : "2"} Review exchange and submit`;
    }
    initiateTracking('edit', 'Recommend an Exchange', eventAction, `Edit - TIFF Exchange ${this.props.selectedTiffOption === "exchangeFromTIFF" ? "FROM" : "INTO"} - ${value} - Stepper`);
  }

  exitFlow = () => {
    const { key } = this.state;
    this.setState({ exitPopUp: false });
    var type = "";
    if (key === "oneTime") { type = "onetime" } else if (key === "recurring") { type = "recurring" }
    initiateTracking('tabClick', 'Recommend an Exchange', '', key === "oneTime" ? "One Time Exchange" : "Recurring Exchange");
    this.props.history.push({
      pathname: "/investments/recommend-an-exchange/NEW/from",
      state: { scheduleType: type, isFromTIFF: true }
    });
    this.props.tabExchange(key);
    this.props.resetFlow();
  };
  stayOnFlow = () => {
    this.setState({ exitPopUp: false });
  };
  checkChangeTab = (key) => {
    if (this.props.selectedTiffOption !== "" || this.props.valueInFormChangeValue) {
      this.setState({ exitPopUp: true, key });
    } else if (this.props.selectedTiffOption == "") {
      this.props.tabExchange(key);
      var type = "";
      if (key === "oneTime") { type = "onetime" } else if (key === "recurring") { type = "recurring" }
      initiateTracking('tabClick', 'Recommend an Exchange', '', key === "oneTime" ? "One Time Exchange" : "Recurring Exchange");
      this.props.history.push({
        pathname: "/investments/recommend-an-exchange/NEW/from",
        state: { scheduleType: type, isFromTIFF: true }
      });
    }
  };
  updateStepper = () => {
    let { stepConfig } = this.state;
    if (this.props.selectedTiffOption === "exchangeFromTIFF") {
      if (stepConfig.length === 3) return;
      stepConfig.splice(1, 0, this.backUpStep2);
      stepConfig[0].description = "Exchange from TIFF";
    } else {
      if (stepConfig.length === 2) return;
      [, this.backUpStep2] = stepConfig;
      stepConfig.splice(1, 1);
      stepConfig[0].description = "Exchange into TIFF";
    }
    stepConfig = stepConfig.map((config, i) => {
      const retConfig = config;
      retConfig.key = i + 1;
      return retConfig;
    });
    stepConfig.every((step, i) => step.status = i === 0 ? 'process' : 'wait')
    this.setState({ stepConfig });
  };
  tabsConfig = () => ({
    extraContent: "Select Schedule Type",
    tabConfig: [
      {
        title: "One Time Exchange",
        key: "oneTime",
        pathname: "/investments/recommend-an-exchange/NEW/from"
      },
      {
        title: "Recurring Exchange",
        key: "recurring",
        pathname: "/investments/recommend-an-exchange/NEW/from"
      },
      {
        title: "TIFF Exchange",
        key: "tiff",
        pathname: "/tiff/recommendAnExchange"
      }
    ]
  });
  breadcrumbRoutes = () => [
    {
      routeName: "Home",
      path: "/"
    },
    {
      routeName: "Investments",
      path: "/investments"
    },
    {
      routeName: "Recommend an Exchange",
      path: ""
    }
  ];

  beforeMainContent = () => (
    <>
      <Alert
        type="Disclaimer for TIFF Exchanges: "
        tiff={true}
        typeFirst={!this.props.expectedEchangeDateLoader ? `Expected Exchange Date: ${this.props.expectedEchangeDate[0].field_date}` : ''}
        typeSecond='Disclaimer for TIFF Exchanges: '
        heading={<
          ContentMessage
          page='Tiff Exchange'
          type={Types.PAGE_NOTICES}
          property='field_notice_content'
          html
          messageId="header"
          defaultMessage="TIFF Exchange recommendations are subject to Vanguard Charitable review and approval." />
        }
        body={<
          ContentMessage
          page='Tiff Exchange'
          type={Types.PAGE_NOTICES}
          property='field_show_more_content'
          html
          messageId="body"
          defaultMessage="" />
        }
      />
      {/* commented as per the ticket OW-84 */}
      {/* <SoftAlert
        className="mt-30 mb-50"
        heading="Expected Exchange Date: "
        date={this.props.expectedEchangeDate[0].field_date}
        mainbody={<
          ContentMessage
          page='Tiff Exchange'
          type={Types.PAGE_DISCLAIMERS}
          property='field_disclaimer_content'
          html
          defaultMessage="If you would like to transfer the entire balance out of TIFF please submit your request at least 48 business hours in advance. If the request is received and the timeframe is less than 48 hours, we will do our best to accommodate the request as soon as possible. Exchanges take two business days to complete, and transaction details will post to the account by the third business day." />
        }
      /> */}
    </>
  );

  componentWillUnmount() {
    this.props.resetInitialFlow();
  }
  componentWillMount() {
    this.props.resetInitialFlow();
    this.props.getExchangeDate({
      method: "GET",
      page: "ViewAndEditInto",
      url: `/api/dates?Page=Expected_Exchange_Date`,
      isExternal: true
    });
    this.props.fetchCustomPoolFee({
      poolId: 17, 
      currentDate: todayDate()
    });
    this.props.requestDataTiff({
      method: "GET",
      page: "recommendAnExchange",
      url: `/donor-portal/api/investment/${
        getPrimaryAccount().userId
        }/findInvestmentPoolOptionsByAccountIdStartDateAndEndDate?startDateStr=${startDate(
          7
        )}&endDateStr=${todayDate()}`
    });
    window.scrollTo(0, 0);
  }
  static getDerivedStateFromProps(props,state) {
    if ((props.accDataPools.currentBalance != state.currentBalance) || (props.formDataSubmitted != state.formDataSubmitted)){
    if (
      (getPrimaryAccount().accountType != "Select" ||
      props.accDataPools.currentBalance < 100000) && (props.accDataPools.investmentPools)
    ) {
      var tiffArray = props.accDataPools.investmentPools && props.accDataPools.investmentPools.filter(item => {
        return item.poolName === "TIFF Multi-Asset Pool"
      });
      if (tiffArray && tiffArray.length !== 0) {
        props.disableFrom(false);
        return { disableSteppers: false,currentBalance: props.accDataPools.currentBalance,formDataSubmitted: props.formDataSubmitted};
      } else {
        // Un-commented based on discussion.
        const [step0,...rest] = state.stepConfig;
        step0.mainContent = () => (
            <TiffNotEligibleForm
              {...props}
              resetInitialFlow={props.resetInitialFlow}
              formDataSubmitted={props.formDataSubmitted}
              valueInFormChange={props.valueInFormChange}
              formDrupalConten={props.formDrupalContent}
              beforeSubmitData={props.beforeSubmitData}
              afterSubmitData={props.afterSubmitData}
            />
          );
        return { disableSteppers: true,stepConfig:[step0,...rest],currentBalance: props.accDataPools.currentBalance,formDataSubmitted: props.formDataSubmitted}
      }
    }
    if (
      getPrimaryAccount().accountType == "Select" &&
      props.accDataPools.currentBalance > 100000 && props.accDataPools.investmentPools
    ) {
      var tiffArray = props.accDataPools.investmentPools && props.accDataPools.investmentPools.filter(item => {
        return item.poolName === "TIFF Multi-Asset Pool"
      });
      if (tiffArray && tiffArray.length !== 0) {
        props.disableFrom(false);
        return { currentBalance: props.accDataPools.currentBalance,formDataSubmitted: props.formDataSubmitted} ;
      } else {
        props.disableFrom(true);
        return { currentBalance: props.accDataPools.currentBalance,formDataSubmitted: props.formDataSubmitted};
      }
    }
  }
  }
  render = () => {
    const {
      availableBalance,
      currentBalance,
      expectedEchangeDateLoader,
      history
    } = this.props;
    //if (expectedEchangeDateLoader) return <Preloader />;
    return (
      <>
        <ContentProvider types={[Types.PAGE_TITLE_DESCRIPTION, Types.PAGE_NOTICES, Types.PAGE_DISCLAIMERS, Types.PAGE_ALERTS]} pages={['Tiff Exchange']}>
          <RecommendFlow
            accData={{
              availableBalance,
              currentBalance
            }}
            beforeMainContent={this.beforeMainContent}
            activeTab="tiff"
            tabsConfig={this.tabsConfig}
            breadcrumbRoutes={this.breadcrumbRoutes()}
            handleTabChange={this.checkChangeTab}
            disableSteppers={this.state.disableSteppers}
            stepConfig={this.state.stepConfig}
            // pageHeader={<
            //   ContentMessage
            //   page='Tiff Exchange'
            //   type={Types.PAGE_TITLE_DESCRIPTION}
            //   property='field_page_title'
            //   defaultMessage="Recommend an Exchange" />
            // }
            pageHeader="Tiff Exchange"
            history={history}
            featureCode="RAE"
          />
          <PopUp
            type="FLOW_CHANGE"
            visible={this.state.exitPopUp}
            onOk={this.exitFlow}
            onCancel={this.stayOnFlow}
          />
        </ContentProvider>
      </>
    );
  };
}

export default withRouter(TIFFRecommendAnExchange);

